/** The words of the quote document admin page (SA-1040 §4.5). Every sentence the page prints is here. */
import { whenText } from '@/components/process/stepLiveText'
import { ApiError } from '@/services/apiClient'

export const PAGE_TITLE = 'Quote document'
export const PAGE_SENTENCE =
  'The letterhead, logo and terms every quotation is rendered with, and the wording of the offer email a prepared quote drafts.'
export const COMPANY_NAME = 'Company name'
export const COMPANY_HINT = 'Empty uses the Business Profile name.'
export const ADDRESS_LINES = 'Address lines'
export const CONTACT_LINES = 'Contact lines'
export const LINES_HINT = 'One per line.'
export const LEGAL_LINE = 'Legal line'
export const LEGAL_HINT = 'The footer: registration, VAT.'
export const PAGE_SIZE = 'Page size'
export const LOGO = 'Logo'
export const LOGO_INPUT = 'Logo image'
export const LOGO_HINT = 'PNG, JPEG or WebP, 5 MB at most; drawn at most 45 × 20 mm.'
export const LOGO_TYPES = ['image/png', 'image/jpeg', 'image/webp']
export const LOGO_MAX_BYTES = 5 * 1024 * 1024
export const LOGO_BAD_TYPE = 'The logo must be a PNG, JPEG or WebP image.'
export const LOGO_TOO_BIG = 'The logo is larger than 5 MB.'
export const PREVIEW_HINT = 'Preview shows the saved settings.'
export const LOGO_REMOVE = 'Remove logo'
export const LOGO_NONE = 'No logo set.'
export const TERMS = 'Terms and conditions'
export const TERMS_HINT = 'Printed under the price, line breaks as typed; a blank line starts a new paragraph. Empty prints no terms block.'
export const EMAIL_SUBJECT = 'Email subject'
export const EMAIL_BODY = 'Email body'
export const EMAIL_HINT = 'Empty uses the default wording. Placeholders: {reference}, {revision}, {company}, {contact_name}, {route}, {dates}, {amount}, {valid_until}, {sender_name}, {our_company}.'
export const SAVE = 'Save'
export const SAVING = 'Saving…'
export const SAVED = 'Saved.'
export const PREVIEW = 'Preview PDF'
export const PREVIEWING = 'Rendering…'
export const LOADING = 'Loading…'
export const UNAVAILABLE = 'The settings could not be loaded.'
export const UPLOAD_FAILED = 'The logo was not uploaded.'
export const PREVIEW_FAILED = 'The preview could not be rendered.'
/** The file a preview downloads as when the browser refused the new tab. */
export const PREVIEW_FILE = 'Quotation-preview.pdf'
export const FORBIDDEN = 'Only an admin can change the quote document.'
export const SAVE_FAILED = 'The settings were not saved. Try again.'

/** "Last saved by Maria on 15 Oct 09:00": `stepLiveText.whenText` in `zone`, the deployment's
 *  (`useDefaultTimezone`), never `toLocaleString`; the year only when it is not `now`'s. */
export function lastSaved(name: string | null, at: string | null, now: Date, zone: string): string | null {
  const when = whenText(at, now, zone)
  if (!when) return null
  return `Last saved by ${name ?? 'someone'} on ${when}`
}

/** The server's sentence for a refused save; never a bare code. */
export function saveErrorText(error: unknown): string {
  if (error instanceof ApiError) {
    const detail = error.detail as { message?: unknown } | null
    if (detail && typeof detail === 'object' && typeof detail.message === 'string') return detail.message
    if (error.status === 403) return FORBIDDEN
  }
  return SAVE_FAILED
}
